var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
import DateService from "./Shared/Date.service";
const advisorURL = "/aviso/advisor";
export default class TranscriptService {
    static getTranscriptForStudent(affiliationId) {
        return FetchService.get(advisorURL + "/getTranscript", { affiliationId });
    }
    // No formal DTOs returned by this endpoint.
    static getTranscriptAcademicTerms(affiliationId) {
        return FetchService.get(advisorURL + "/getTranscriptAcademicTerms", {
            affiliationId,
        });
    }
    static getTranscriptHistoryData({ transcriptId, period, aggregation, property, toDate, fromDate, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getApiClient().get("/stats/getTranscriptGpaHistoryData", {
                params: {
                    transcriptId,
                    period,
                    aggregation,
                    property,
                    toDate,
                    fromDate,
                },
            });
            // @ts-expect-error - TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => ({
                data: datum.data,
                date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)),
            }));
        });
    }
    // prettier-ignore
    static getTranscriptCourseAttendanceAttendedAndMissedByTermCounts(transcriptId, period, rangeFrom, rangeTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getApiClient().get("/stats/getAttendedAndMissedByTerm", {
                params: { transcriptId, period, rangeFrom, rangeTo },
            });
            // @ts-expect-error - TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => ({
                numAttended: datum.numAttended,
                numMissed: datum.numMissed,
                date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)),
            }));
        });
    }
}
